import api from "../../../";
import type { ApiResponse } from "../../../types";
import type { CommunityQuestion, UpdateCommunityQuestionParams } from "./types";

export const patchCommunityQuestion = async ({ id, body }: UpdateCommunityQuestionParams): Promise<CommunityQuestion | null> => {
  return await api.patch<ApiResponse<CommunityQuestion>>(`/admin/sepehr/questions/${id}/`, body)
    .then((res) => res.data.data)
    .catch(() => null);
};

